export function hashReceipt(receiptNo) {
  let hash = 0
  const text = String(receiptNo || '').trim()
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash << 5) - hash + text.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

function pickByHash(list, seed) {
  if (!Array.isArray(list) || list.length === 0) return null
  return list[seed % list.length]
}

function buildPurchaseBasket(receiptNo, categories) {
  const hash = hashReceipt(receiptNo)
  const basket = []

  for (let i = 0; i < 4; i += 1) {
    const category = categories[(hash + i * 7) % categories.length]
    const qty = ((hash >> (i + 2)) % 5) + 1
    const item = pickByHash(category.items, hash + i * 13)
    basket.push({
      categoryId: category.id,
      categoryLabel: category.label,
      itemName: item,
      element: category.element,
      quantity: qty
    })
  }

  return basket
}

function scoreElements(basket) {
  return basket.reduce((acc, item) => {
    acc[item.element] = (acc[item.element] || 0) + item.quantity
    return acc
  }, {})
}

export function createMysticReading(receiptNo, aiData) {
  const categories = aiData?.purchaseCategories || []
  const elementMeta = aiData?.elements || {}
  if (!categories.length) return null

  const hash = hashReceipt(receiptNo)
  const phase = hash % 3
  const basket = buildPurchaseBasket(receiptNo, categories)
  const elementScores = scoreElements(basket)
  const dominantElementId = Object.entries(elementScores).sort((a, b) => b[1] - a[1])[0]?.[0] || 'water'
  const dominantElement = elementMeta[dominantElementId]
  const dominantProduct = basket.filter((item) => item.element === dominantElementId)[0]
  const isFortuneUp = hash % 2 === 0
  const fortuneKey = isFortuneUp ? 'rise' : 'balance'
  const fortuneTemplate = aiData?.fortuneTemplates?.[fortuneKey]
  const elementFortunes = Array.isArray(dominantElement?.fortunes) ? dominantElement.fortunes : []
  const selectedElementFortune = pickByHash(elementFortunes, hash + phase * 17)

  const graphSets = [
    [68, 35, 74, 28, 63],
    [54, 72, 44, 70, 40],
    [61, 42, 79, 36, 58]
  ]

  const now = new Date()
  const currentDateTime = now.toLocaleString('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })

  return {
    receiptNo,
    purchasedItems: basket,
    dominantProduct,
    dominantElementId,
    dominantElementLabel: dominantElement?.label || 'ธาตุน้ำ',
    dominantElementSymbol: dominantElement?.symbol || '💧',
    dominantElementMeaning: dominantElement?.meaning || '',
    elementKeywords: dominantElement?.keywords || [],
    fixProducts: dominantElement?.fixProducts || [],
    boostProducts: dominantElement?.boostProducts || [],
    graphPoints: graphSets[phase],
    currentDateTime,
    fortuneStatus: fortuneTemplate?.status || 'ดวงขึ้น',
    fortuneHeadline: selectedElementFortune?.headline || fortuneTemplate?.headline || 'ถ้าดวงดี',
    fortuneMessage: selectedElementFortune?.message || fortuneTemplate?.message || '',
    fortuneUpgradeText: fortuneTemplate?.upgradeText || '',
    remedyHeadline: fortuneTemplate?.adviceTitle || 'คำแนะนำ',
    remedyList: fortuneTemplate?.adviceBullets || [],
    fortuneTone: fortuneKey,
    fortuneVariantCount: elementFortunes.length,
    fortuneVariantIndex: selectedElementFortune ? elementFortunes.indexOf(selectedElementFortune) + 1 : 0
  }
}
